
import { DOCUMENT, Injectable, inject } from '@angular/core';
import { Product } from 'src/app/products/models/product.model';
import { PriceService } from 'src/app/products/services/price.service';

@Injectable({
  providedIn: 'root'
})
export class JsonLdService {
  private _document = inject<Document>(DOCUMENT);


  static scriptType = 'application/json+ld';

  static productSchema = (product: Product) => {

    // get seo details
    const { seo_detail } = product || {};

    // price to check offer
    const { actualPrice, sellingPrice } = PriceService._getProductPrice(product);

    let description = '';
    if (seo_detail?.meta_description) {
      description = seo_detail.meta_description;
    } else if (product?.short_description) {
      description = product.short_description;
    } else if (product?.one_line_description) {
      description = product.one_line_description;
    } else if (product?.highlights) {
      description = product?.highlights?.join(',');
    }


    return ({

      '@context': 'https://schema.org/',
      '@type': 'Product',
      name: product?.name,
      image: product?.featured_images?.map(feature_image => feature_image?.url) ?? [],
      description,
      sku: product?.sku,
      /* mpn: product?., */
      brand: {
        '@type': 'Brand',
        name: product?.brand?.name
      },
      review: {
        '@type': 'Review',
        reviewRating: {
          '@type': 'Rating',
          ratingValue: 5,
          bestRating: 5
        }
      },
      aggregateRating: {
        '@type': 'AggregateRating',
        ratingValue: 5,
        reviewCount: 999
      },
      ...(sellingPrice < actualPrice && {
        offers: {
          '@type': 'Offer',
          url: product?.url_path,
          priceCurrency: 'INR',
          price: sellingPrice,
          /* priceValidUntil: 2020 - 11 - 20, */
          itemCondition: 'https://schema.org/NewCondition',
          availability: 'https://schema.org/InStock'
        }
      })
    });
  }

  removeStructuredData(): void {
    const els: Element[] = [];
    ['structured-data', 'structured-data-org'].forEach(c => {
      const elements = this._document.head.getElementsByClassName(c);
      els.push(...Array.from(elements as HTMLCollectionOf<Element>));
    });
    els.forEach(el => this._document.head.removeChild(el));
  }

  insertSchema(schema: Record<string, any>, className = 'structured-data'): void {
    let script: HTMLScriptElement;
    let shouldAppend = false;
    if (this._document.head.getElementsByClassName(className).length) {
      script = this._document.head.getElementsByClassName(className)[0] as HTMLScriptElement;
    } else {
      script = this._document.createElement('script');
      shouldAppend = true;
    }
    script.setAttribute('class', className);
    script.type = JsonLdService.scriptType;
    script.text = JSON.stringify(schema);
    if (shouldAppend) {
      this._document.head.appendChild(script);
    }
  }

}
